// Module
var code = `<div on-click="@this.onClick(event)"
     class="{{.styleClassed}}"
     style="{{#.width}}width:{{.width}}px;{{/}}
        {{#.top}}top:{{.top}}px;{{/}}
        {{#.left}}left:{{.left}}px;{{/}}
        {{^.visible}}display:none;{{/}}
        {{^.showArrow}} background-image: none;{{/}}"
     {{#.focused}} focused="" {{/}}
     {{#if !(.enabled) || !(.items.length)}} disabled="" {{/if}}>

    <div as-tooltip="tooltip" {{#.usePNGView}} style="height:100%; width:100%;"
         class="{{.selectedItem.style}} {{.updateComboBoxClass}}" {{/}}>
        {{^.usePNGView}}{{#.selectedItem}}{{.text}}{{/}}{{/}}
    </div>
</div>`;
// Exports
export default code;